import { theme } from '@msc/lib.theme'

import Button from 'primevue/button'
import PrimeVue from 'primevue/config'
// import Dialog from 'primevue/dialog'

import axios from '@/utils/axios'
import App from './App.vue'

async function init() {
  const token = useStorage('msc.token')
  const locked = useStorage('msc.locked')

  // clear session
  const clearSession = () => {
    locked.value = null
    token.value = null
  }

  // check session
  if (token.value) {
    try {
      console.log(`Refreshing session... ${token.value}`)
      const { data } = await axios.post('auth/refresh', { token: token.value })
      if (!data.refresh) throw new Error('Invalid refresh token')
      token.value = data.refresh
      window.location.reload()
      return
    } catch (error) {
      clearSession()
    }
  }

  const app = createApp(App)
  const loadedTheme = await theme.load()

  app.use(createPinia())
  app.use(PrimeVue, { theme: { preset: loadedTheme, options: { darkModeSelector: false || 'none' } } })
  /*   app.component('Button', Button)
  app.component('Dialog', Dialog) */

  app.mount('#app')
  // create app
  // await theme.load('berthold')
}

init()
